import "./style.scss";

import BookIcon from "assets/img/svg/documentationBookIcon";
import { localizeDocLink } from "helpers/docLink";

interface IDocumentationLink {
    title: string;
    description: string;
    link: string | undefined;
    style?: React.CSSProperties;
}
/**
 * @param {string} title Title of the documentation
 * @param {string} description Description of the documentation
 * @param {string} link Link to the documentation
 */
const DocumentationLink = ({ title, description, link, style }: IDocumentationLink) => {
    const onOpenDocumentation = () => {
        window.open(localizeDocLink(link ?? ""), "_blank");
    };
    return (
        <div className="doc-link-wrapper" onClick={onOpenDocumentation} style={style}>
            <div className="doc-link-title-wrapper">
                <BookIcon />
                <span className="doc-title">{title}</span>
            </div>
            <span className="doc-link-description">{description}</span>
        </div>
    );
};

export default DocumentationLink;
